import React, { useState, useEffect } from 'react';
import { usePlatformIssues } from '../data/PlatformIssueStore';
import { usePitchMode } from '../hooks/usePitchMode';

const StatusBanner: React.FC = () => {
    const { issues } = usePlatformIssues();
    const pitchMode = usePitchMode();
    const [dismissed, setDismissed] = useState<Set<string>>(new Set());

    const activeIssues = pitchMode ? [] : issues.filter(
        (i) =>
            (i.status === 'OPEN' || i.status === 'IN_PROGRESS') &&
            (i.issueType === 'System Bug' || i.issueType === 'Performance Issue') &&
            !dismissed.has(i.id)
    );

    useEffect(() => {
        const stored = sessionStorage.getItem('spartis_dismissed_banners');
        if (stored) {
            try { setDismissed(new Set(JSON.parse(stored))); } catch {}
        }
    }, []);

    const dismiss = (id: string) => {
        const next = new Set(dismissed);
        next.add(id);
        setDismissed(next);
        sessionStorage.setItem('spartis_dismissed_banners', JSON.stringify(Array.from(next)));
    };

    if (activeIssues.length === 0) return null;

    return (
        <div style={{ width: '100%' }}>
            {activeIssues.slice(0, 3).map((issue) => (
                <div
                    key={issue.id}
                    style={{
                        background: issue.urgency === 'HIGH' ? '#fef2f2' : '#fffbeb',
                        borderBottom: `2px solid ${issue.urgency === 'HIGH' ? '#fca5a5' : '#fcd34d'}`,
                        padding: '8px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 10,
                        fontSize: 13,
                        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                    }}
                >
                    <span style={{ fontSize: 16 }}>
                        {issue.urgency === 'HIGH' ? '🔴' : '⚠️'}
                    </span>
                    <span style={{ fontWeight: 700, color: issue.urgency === 'HIGH' ? '#991b1b' : '#92400e' }}>
                        {issue.issueType}:
                    </span>
                    <span style={{ color: issue.urgency === 'HIGH' ? '#7f1d1d' : '#78350f', flex: 1 }}>
                        {issue.title}.
                        {issue.status === 'IN_PROGRESS' && (
                            <span style={{ fontStyle: 'italic', marginLeft: 6, opacity: 0.8 }}>
                                Fix in progress.
                            </span>
                        )}
                        {issue.status === 'OPEN' && (
                            <span style={{ fontStyle: 'italic', marginLeft: 6, opacity: 0.8 }}>
                                Under investigation.
                            </span>
                        )}
                    </span>
                    <button
                        onClick={() => dismiss(issue.id)}
                        style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            fontSize: 16,
                            color: '#9ca3af',
                            padding: '2px 6px',
                            borderRadius: 4,
                        }}
                        title="Dismiss"
                    >
                        ✕
                    </button>
                </div>
            ))}
        </div>
    );
};

export default StatusBanner;
